import React, {useEffect} from "react";
import {Routes, Route} from "react-router-dom";
import AccessoriesType from "../../layout/product/accessories/AccessoriesType";
import AddAccessoriesType from "../../layout/product/accessories/AddAccessoriesType";
import PriceLayout from "../../layout/product/PriceLayout";

const AccessoriesTypePage = () => {
    useEffect(() => {
        return () => {
            localStorage.removeItem("acselectedId");
            localStorage.removeItem("acitemOffset");
            localStorage.removeItem("acforcePage");
        };
    }, []);

    return (
        <>
            <Routes>
                <Route path="/" element={<AccessoriesType/>}/>
                <Route path="/add" element={<AddAccessoriesType/>}/>
                <Route path="/update/:id" element={<AddAccessoriesType/>}/>
                <Route path="/price/:id/:name" element={<PriceLayout/>}/>
            </Routes>
        </>
    );
};

export default AccessoriesTypePage;
